var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlataformaPai = function SvgPlataformaPai(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "2 3 21 18",
    style: {
      transform: "rotate(0deg)"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M6.74 6.001L2.567 6c-.068 0-.108.072-.071.126l1.422 2.112a.158.158 0 00.131.068H6.74c1.682 0 2.237.535 2.237 1.53 0 .996-.555 1.513-2.237 1.513h-.555c-.076 0-.123.082-.081.144l1.372 2.04a.18.18 0 00.164.079c2.698-.2 3.898-1.58 3.898-3.775C11.538 7.55 10.18 6 6.74 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M15.101 12.59h-1.834a.166.166 0 01-.154-.225l.914-2.432a.178.178 0 01.334 0l.907 2.414a.18.18 0 01-.167.243zm4.831 5.165L15.556 6.116A.178.178 0 0015.39 6h-2.371a.179.179 0 00-.168.116l-1.004 2.658a.338.338 0 00-.013.192c.36 1.632-.173 3.45-1.516 4.24a.548.548 0 00-.23.282l-1.613 4.267a.18.18 0 00.168.244h2.236c.075 0 .141-.047.167-.117l1.079-2.868a.179.179 0 01.167-.117h3.824c.075 0 .141.047.168.117l1.078 2.868a.18.18 0 00.167.117h2.237a.18.18 0 00.167-.244zM21.821 6h-2.204a.18.18 0 00-.178.18l-.003 9.076c0 .108.019.216.057.318l.758 2.016c.056.136.042.281-.022.367-.012.017 0 .04.02.04l1.572.002a.18.18 0 00.179-.18V6.179A.18.18 0 0021.821 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB7000",
    d: "M2.163 6.242l4.899 7.296c.035.053-.004.121-.068.121h-2c-.1 0-.182.079-.182.176v3.989A.179.179 0 014.63 18H2.182A.18.18 0 012 17.824V6.288c0-.085.115-.118.163-.046z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlataformaPai, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plataforma-pai.87d64233.svg";
export { ForwardRef as ReactComponent };